import SubscribeForm from '@/components/feature/SubscribeForm';

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="px-4 md:px-6 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-5">
          <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.28em] uppercase text-primary-700">
            <span className="w-6 h-px bg-primary-500" />
            订阅线报
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            每周一封信，跟进你错过的后续
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            热点散得快，跟进却需要耐心。我们用一封整理信，把一周内新增的深挖选题、值得一看的图解和正在跟进的线索方向打包寄出。
          </p>
          <ul className="mt-6 space-y-3">
            {['不推送无关内容，随时可退订', '只寄整理结果，不做营销', '含未成稿线索方向，读者优先'].map((text) => (
              <li key={text} className="flex items-center gap-2.5 text-sm text-foreground-700">
                <span className="w-5 h-5 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center shrink-0">
                  <i className="ri-check-line text-xs" />
                </span>
                {text}
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-7">
          <SubscribeForm />
        </div>
      </div>
    </section>
  );
}